import {
  UPDATE_FILTER,
  RESET_FILTER,
  TOGGLE_FILTER,
} from 'config/types';
import { map as colors } from 'config/colors';

export default function filterReducer(state = {}, { type = '', payload = {} }) {
  if (UPDATE_FILTER === type) {
    const unusedColors = colors.filter((color) =>
      -1 === Object.values(state.chartColorsUsed).indexOf(color));
    const chartColorsUsed = payload.geos.reduce((acc, geo) => ({
      ...acc,
      [geo]: state.chartColorsUsed[geo] || unusedColors.shift(),
    }), {});
    return {
      ...state,
      chartColorsUsed,
      tableFilter: payload.geos,
      seriesAdd: payload.add,
    };
  }
  if (RESET_FILTER === type) {
    const { indicator: { dataView } } = state;
    const defaultFilter = {
      usdata: ['US'],
      international: ['WORLD'],
    };
    return {
      ...state,
      tableFilter: defaultFilter[dataView] || [],
      seriesAdd: false,
    };
  }
  if (TOGGLE_FILTER === type) {
    return {
      ...state,
      tableFilterToggle: !state.tableFilterToggle,
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/filter.js